module.exports = __webpack_public_path__ + "assets/img/returnBtn-6c4e94e9.png";